module.exports = __webpack_public_path__ + "img/government-right-2.9696758d.png";